import { render, staticRenderFns } from "./IconDivider.vue?vue&type=template&id=4d173c8e"
import script from "./IconDivider.vue?vue&type=script&lang=js"
export * from "./IconDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports